import React from 'react'

const WarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 16.2017H18L9 0.65625L0 16.2017ZM9.81843 13.7471H8.18207V12.1107H9.81843V13.7471ZM9.81843 10.4745H8.18207V7.20177H9.81843V10.4745Z"
        fill="white"
      />
    </svg>
  )
}

export default WarningIcon
